import React from "react";
import "./styles.less";

export const Developing = () => {
  return (
    <div className="feature-developing">
      <img
        width="222px"
        src="//files.authing.co/authing-blog/feature-developing.png"
        alt="Please wait"
      />
      <div
        style={{
          color: "#666",
          marginTop: 30,
        }}
      >
        正在建设中，敬请期待！
      </div>
    </div>
  );
};
